import * as Yup from 'yup';

export const searchValidateSchema = (t) =>
  Yup.object().shape({
    loading_address_radius: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .min(1, t('errors.radiusMustBePositive')),
    unloading_address_radius: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .min(1, t('errors.radiusMustBePositive')),
  });
